'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var bytes = require('../bytes.js');

const raw = bytes$1 => bytes.coerce(bytes$1);
const {name, code, encode, decode} = {
  name: 'raw',
  code: 85,
  decode: raw,
  encode: raw
};

exports.code = code;
exports.decode = decode;
exports.encode = encode;
exports.name = name;
